module.exports = "<div class=\"youtubeContentWrapper videowrapper\">\r\n  <iframe [id]=\"'ytplayer'\" type=\"text/html\" [src]=\"videoIframeUrl\" frameborder=\"0\" allowfullscreen></iframe>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/ProactiView/ProactiView-Client/src/app/shared/youTubeEmbeder/youTubeEmbeder.component.html
// module id = ../../../../../src/app/shared/youTubeEmbeder/youTubeEmbeder.component.html
// module chunks = main